import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'
import { gtoWizardAppUrl } from '@gto/urls'

import Bg from '@/assets/images/world-map-background.png'

export const RootRoute = () => {
  return (
    <div
      className="flex h-[100dvh] flex-col items-center justify-center gap-6 bg-center bg-no-repeat text-center"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <Typography
        color="primary"
        component="h1"
        variant="h3"
      >
        <FormattedMessage id="blocked.title" />
      </Typography>
      <Typography
        color="text.secondary"
        variant="h6"
      >
        <FormattedMessage id="blocked.description" />
      </Typography>
      <Button
        color="primary"
        component="a"
        href={gtoWizardAppUrl}
        size="large"
        variant="contained"
      >
        <FormattedMessage id="common.controls.goToGto" />
      </Button>
    </div>
  )
}
